import { StoreInterface, StoreUpdateInterface } from 'modules/stores/types/stores-interface'

export const getStoreUpdateData = (store: StoreInterface): StoreUpdateInterface => {
  const { image, ...seoAttrs } = store.seo

  return {
    domainId: store.domainId,
    path: store.path,
    name: store.name,
    active: store.active,
    locale: store.locale,
    paymentMethods: store.paymentMethods,
    currency: store.currency,
    displayAffiliateLink: store.displayAffiliateLink,
    seo: { ...seoAttrs, imageId: image?.id ?? null },
  }
}
